import React, { useState } from "react";
import { useCarrito } from "../context/CarritoContext";
import { FiShoppingCart } from "react-icons/fi";
import VistaCarrito from "./VistaCarrito";
import ModalCarrito from "./ModalCarrito";

export default function BotonCarrito() {
  const { carrito } = useCarrito();
  const [showMiniCart, setShowMiniCart] = useState(false);
  const [showFullModal, setShowFullModal] = useState(false);

  const cantidadTotal = carrito.reduce((sum, p) => sum + p.cantidad, 0);

  const handleAmpliarClick = () => {
    setShowMiniCart(false);
    setShowFullModal(true);
  };

  return (
    <>
      {/* Botón del carrito */}
      <button
        onClick={() => setShowMiniCart(!showMiniCart)}
        className="fixed bottom-6 right-6 z-50 bg-sky-600 text-white p-4 rounded-full shadow-lg hover:bg-sky-700 transition"
      >
        <FiShoppingCart size={24} />
        {cantidadTotal > 0 && (
          <span className="absolute top-0 right-0 -mt-1 -mr-1 bg-red-600 text-xs text-white rounded-full px-2">
            {cantidadTotal}
          </span>
        )}
      </button>

      {/* Mini carrito */}
      {showMiniCart && (
        <div className="fixed bottom-28 right-6 z-40 w-80 bg-white rounded-lg shadow-xl">
          <VistaCarrito
            cerrar={() => setShowMiniCart(false)}
            minimizar={() => setShowMiniCart(false)}
            estaMinimizado={false}
            ampliar={handleAmpliarClick}
          />
        </div>
      )}

      {/* Modal completo */}
      {showFullModal && (
          <ModalCarrito
            cerrar={() => setShowFullModal(false)}
          />
      )}
    </>
  );
}
